export const chatEndpoints = {
  // Token — appelé via BffApiClient directement (avant que le acsToken ne soit dispo)
  getToken: (mail: string, platform: string, notificationToken?: string) => {
    const params = new URLSearchParams({ mail, platform });
    if (notificationToken) params.append('notificationToken', notificationToken);
    return `/api/chat/token?${params.toString()}`;
  },

  // Conversations — le token ACS est injecté automatiquement par ChatApiClient
  getConversations: '/api/chat/threads/me',

  createConversation: '/api/chat/threads',

  deleteConversation: (threadId: string) => `/api/chat/threads/${threadId}`,

  // Participants
  addParticipants: (threadId: string) => `/api/chat/threads/${threadId}/participants`,

  removeParticipant: (threadId: string, participantMail: string) =>
    `/api/chat/threads/${threadId}/participants/${participantMail}`,

  // Topic
  updateTopic: (threadId: string) => `/api/chat/threads/${threadId}/topic`,

  // Messages
  getMessages: (threadId: string, limit?: number) => {
    const base = `/api/chat/threads/${threadId}/messages`;
    if (!limit) return base;
    return `${base}?limit=${limit}`;
  },

  sendMessage: (threadId: string) => `/api/chat/threads/${threadId}/messages`,

  sendAttachment: (threadId: string) => `/api/chat/threads/${threadId}/messages/attachments`,
};

// StudentsSearchService — reste sur WardApiClient, routes inchangées
export const studentsSearchEndpoints = {
  search: (query: string, limit = 10, offset = 0) => {
    const params = new URLSearchParams({
      search: query || '',
      limit: limit.toString(),
      offset: offset.toString(),
    });
    return `/students?${params.toString()}`;
  },

  searchWithPagination: (query: string, limit = 10, offset = 0) => {
    const params = new URLSearchParams({
      search: query || '',
      limit: limit.toString(),
      offset: offset.toString(),
    });
    return `/students/search?${params.toString()}`;
  },

  getByEmail: (email: string) => `/students/by-email/${encodeURIComponent(email)}`,

  getById: (id: number) => `/students/${id}`,
};
